/**
 * Loading state while validating token.
 */

import { useTranslation } from "react-i18next";
import { Card, CardContent } from "~/components/ui/card";
import { Loader2 } from "lucide-react";

export function LoadingState() {
  const { t } = useTranslation();

  return (
    <div className="w-full py-6 sm:py-12 px-0 sm:px-4" role="status" aria-busy="true">
      <div className="mx-auto max-w-lg">
        <Card className="rounded-none sm:rounded-lg border-x-0 sm:border-x">
          <CardContent className="flex flex-col items-center justify-center py-12">
            <Loader2 className="h-8 w-8 animate-spin text-primary mb-4" aria-hidden="true" />
            <h1 className="sr-only">{t("common.loading", "Loading")}</h1>
            <p className="text-muted-foreground" aria-live="polite">
              {t("onboarding.token.validating")}
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
